import {
  createRouter,
  createWebHashHistory,
  createWebHistory,
  RouteRecordRaw,
} from "vue-router";
import Home from "../views/Home.vue";
import programs from "@/program";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/:id",
    name: "Detail",
    component: () => import("../views/Detail.vue"),
  },
];

const router = createRouter({
  // history: createWebHashHistory(),
  history: createWebHistory(),
  routes,
});

router.afterEach((to, from) => {
  const piwik = (window as any)._paq;
  const program = programs.find((program) => program.slug === to.params.id);
  const title = program
    ? "Betafilm Screeningroom - " + program.title
    : "Betafilm Screeningroom";
  document.title = title;
  piwik.push(["setCustomUrl", to.fullPath]);
  piwik.push(['setDocumentTitle', title]);
  piwik.push(["trackPageView"]);
  piwik.push(["enableLinkTracking"]);
  window.setTimeout(() => {
    piwik.push(["MediaAnalytics::scanForMedia"]);
  }, 3000);
});

export default router;
